import { http } from "@canvas/api";

export interface SwatchLendingCreateReq {
  endpoint: "ragnarok.swatch.v1.lendings.create";
  body: SwatchLendingRequestBody;
}

export interface SwatchLendingRequestBody {
  inventory_id: number;
  issued_to: number;
  issue_remarks: string | null;
  expected_return_date: string | null;
}

export interface SwatchLendingCreateRes {}

export function post(
  req: SwatchLendingCreateReq
): Promise<SwatchLendingCreateRes> {
  return http
    .POST(`/ragnarok/swatch/v1/lendings`, JSON.stringify(req.body))
    .then((response: SwatchLendingCreateRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
